import { PropTypes } from 'react'

export default {
  onZoom: PropTypes.func.isRequired,
  onPan: PropTypes.func.isRequired,
  onRelease: PropTypes.func,
  zoom: PropTypes.number.isRequired
}
